(() => {
  const init = (root = document) => {
  const heroElement = root.querySelector('.hero-track');
  if (!heroElement || heroElement.dataset.initialized) return;
  heroElement.dataset.initialized = 'true';
  const controller = new AbortController();
  if (root !== document) root.addEventListener('shopify:section:unload', () => controller.abort(), { once: true });
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const hero = root.querySelector('.hero-track');
  const header = root.querySelector('.site-header');
  root.querySelectorAll('[data-reveal]').forEach(el => el.removeAttribute('data-reveal'));
  const reveal = [...root.querySelectorAll('main h2,.service h3,.service p,.service button,.speaker-reveal,.catalog-copy p,.catalog-copy .button,.about-copy > *,details,.contact > div > p,.contact > div > .buttons,form label,form small,form .buttons,footer')];
  reveal.forEach(el => el.setAttribute('data-reveal',''));
  document.body.classList.add('motion-ready');
  const groups = [...root.querySelectorAll('main > section:not(.hero-track),footer')].map(section => ({section, elements:reveal.filter(el=>el===section || section.contains(el)), entered:false}));
  let ticking = false;
  const update = () => {
    const amount = Math.max(0, Math.min(1, -hero.getBoundingClientRect().top / (innerHeight * .75)));
    hero.style.setProperty('--progress', reduced.matches ? 0 : amount.toFixed(4));
    header.classList.toggle('scrolled', scrollY > 80);
    const total = document.documentElement.scrollHeight - innerHeight;
    document.documentElement.style.setProperty('--page', reduced.matches ? 0 : Math.max(0, Math.min(1, scrollY / Math.max(1, total))).toFixed(4));
    const catalog = root.querySelector('#catalogo');
    const rect = catalog.getBoundingClientRect();
    catalog.style.setProperty('--catalog-progress', reduced.matches ? 0 : Math.max(0, Math.min(1, (innerHeight - rect.top) / (innerHeight + rect.height))).toFixed(4));
    // Complete the whole section entrance, then retain its readable state.
    // Lower controls must not remain blurred when the section is at its reading stop.
    groups.forEach(group => {
      if (group.entered) return;
      const rect = group.section.getBoundingClientRect();
      // At the page end, short sections such as the footer cannot reach the usual trigger.
      const visibleAtEnd = scrollY >= total - 1 && rect.top < innerHeight;
      if (reduced.matches || rect.top < innerHeight * .82 || visibleAtEnd) {
        group.entered = true;
        group.elements.forEach(el => el.style.setProperty('--focus', '1'));
      }
    });
    ticking = false;
  };
  const schedule = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
  addEventListener('scroll', schedule, { passive:true, signal:controller.signal });
  addEventListener('resize', schedule, { signal:controller.signal });
  reduced.addEventListener('change', update, { signal:controller.signal });
  update();
  addEventListener('load', schedule, { signal:controller.signal });
  root.querySelectorAll('details').forEach(el => el.addEventListener('toggle', schedule));
  root.querySelectorAll('[data-service]').forEach(button => button.addEventListener('click', () => {
    root.querySelector('#service').value = button.dataset.service;
    root.querySelector('#service').focus({preventScroll:true});
    root.querySelector('#contacto').scrollIntoView({behavior:reduced.matches?'instant':'smooth'});
  }));
  root.querySelector('#consulta').addEventListener('submit', event => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);
    const email = form.dataset.email;
    const phone = form.dataset.whatsapp.replace(/\D/g, '');
    const channel = event.submitter?.value || 'whatsapp';
    const message = [
      'Hola, quiero consultar un proyecto con ERNIEPRODU.',
      '',
      `Servicio: ${data.get('servicio')}`,
      `Nombre: ${String(data.get('nombre')).trim()}`,
      `Correo: ${String(data.get('correo')).trim()}`,
      '',
      String(data.get('proyecto')).trim()
    ].join('\n');
    const destination = channel === 'correo'
      ? `mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent('Consulta de proyecto · ' + data.get('servicio'))}&body=${encodeURIComponent(message)}`
      : `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    const result = root.querySelector('#resultado');
    result.className = 'success';
    result.replaceChildren();
    const note = document.createElement('span');
    note.textContent = channel === 'correo'
      ? `Revisa y envía tu consulta desde tu aplicación de correo. Si no se abre, escribe a ${email}. `
      : 'Para completar tu consulta, pulsa Enviar en WhatsApp. ';
    const fallback = document.createElement('a');
    fallback.textContent = channel === 'correo' ? 'Abrir correo' : 'Abrir WhatsApp';
    fallback.href = destination;
    if (channel !== 'correo') {
      fallback.target = '_blank';
      fallback.rel = 'noopener';
    }
    result.append(note, fallback);
    if (channel === 'correo') window.location.href = destination;
    else window.open(destination, '_blank', 'noopener');
  });
  root.querySelector('#consulta fieldset').disabled = false;
  };
  document.addEventListener('shopify:section:load', event => init(event.target));
  init(document.querySelector('.hero-track')?.closest('.shopify-section') || document);
})();
